import { FormEvent } from 'react'

export type FormHandler = (event: FormEvent) => void

export const handleInvalid: FormHandler = (event) => event.preventDefault()
export const handleBlur: FormHandler = (event) => event.preventDefault()
